import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery } from '@grandvisionhq/common';
import { useConfiguratorContext } from '@grandvisionhq/configurator';
import '@swc/helpers';
import '@grandvisionhq/elements';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/state';
import '@grandvisionhq/lib-visuals';
import '@grandvisionhq/utils';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/api-client';
import '../../../state/actions.js';
import '../../../state/add-to-cart/selectors.js';
import '../../../state/bundles/selectors.js';
import '../../../state/bundles/reducer.js';
import '../../../state/configurator/selectors.js';
import '../../../state/configurator/reducer.js';
import '../../../state/products/selectors.js';
import '../../../state/products/reducer.js';
import '@grandvisionhq/commercetools';
import '@grandvisionhq/icons';
import { SelectionsSummary } from '../../../components/SelectionsSummary/SelectionsSummary.js';

const DesktopStepLayout = ({ children , alternativeRightContent  })=>{
    const isAboveTabletPortrait = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT);
    const { isFooterOpen  } = useConfiguratorContext();
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('desktop-step-layout', {
            'desktop-step-layout--summary-expanded': isFooterOpen
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "desktop-step-layout__left"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "desktop-step-layout__content"
    }, children)), isAboveTabletPortrait && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "desktop-step-layout__divider"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "desktop-step-layout__right"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "desktop-step-layout__content"
    }, !!alternativeRightContent ? alternativeRightContent : /*#__PURE__*/ React.createElement(SelectionsSummary, null)))));
};

export { DesktopStepLayout as default };
//# sourceMappingURL=DesktopStepLayout.js.map
